import { Modal, Button, Checkbox, ModalProps, ButtonProps } from "antd";
import classes from "./ModalAddBank.module.css";
import { IModalAddBankProps } from "../../../../interfaces/props/AdminAgentInfo/IModalAddBankProps";

export const ModalAddBank = ({
  width = 700,
  footer = false,
  onCancel,
  open,
  cancelButtonProps = {},
  banks,
}: IModalAddBankProps) => {
  return (
    <Modal width={width} footer={footer} onCancel={onCancel} open={open}>
      <div className={classes.modalTitle}>Добавить банк</div>

      <div className={classes.addSectionTitle}>
        Выберите банки для добавления
      </div>

      <div className={classes.bankList}>
        <div className={classes.bankListContent}>
          {banks?.map((el) => {
            return <Checkbox key={el.id}>{el.title}</Checkbox>;
          })}
        </div>
      </div>

      <div className={classes.modalFooter}>
        <Button size="middle" variant="solid" color={"primary"}>
          Добавить
        </Button>
        <Button {...cancelButtonProps} size="middle">
          Отменить
        </Button>
      </div>
    </Modal>
  );
};
